import React, { Component } from "react";
import GridTable from "@/components/display/table/gridTableCore";
import FormCore from "@/components/display/form/formCore";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { getUserList, getRoleList } from "@/fetch/fetchApi";
import "../../../assets/stylus/com/dataentry/transfer.styl";
import PropTypes from "prop-types";
import { initModals } from "@/state/action/comAction";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import AddAccountModal from "./addAccountModal";
import DispatchRoleModal from "./dispatchRoleModal";

@connect((state) => state)
class Home extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.account;
    console.log(this.internationalization);
    this.init();
    this.noData = {
      emptyText: this.internationalization.msg1, // '暂无数据'
    };
    this.state = {
      gridData: null,
      modalVisible: !1,
      modalTitle: "",
      confirmLoading: !1,
      fromData: [],
      defaultTarget: [],
      inputValue: "",
      defaultTitle: "",
      defaultType: undefined,
      listData: [],
      width: 800,
      loading: !1,
      showFlag: !0,
    };
    // 定义modals
    this.modalConfig = [
      {
        key: "addUserModal",
        width: 500, // 自定义模态框宽度
        title: this.internationalization.btn1, // '添加用户', // 模态窗口的标题
        content: AddAccountModal, // 自定义 jsx内容
      },
      {
        key: "dispatchRoleModal",
        width: 520,
        title: this.internationalization.btn2, // '分配角色',
        content: DispatchRoleModal,
      },
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  init() {
    this.title = this.internationalization.title1; // '用户管理';
    this.subTitle = this.internationalization.title2; // '用户列表';
    this.query = {};
    // home-table
    this.tableConfig = {
      tableKey: "accountTable",
      tableColumns: [
        {
          name: this.internationalization.title3, // '用户名称',
          key: "name",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.title4, // '用户电话',
          key: "phone",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.title5, // '用户邮箱',
          key: "email",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          align: "center",
          colType: "action",
          actionMap: [
            {
              type: "href",
              actionName: this.internationalization.btn3, // '分配角色',
              handler: (res) => {
                const targetArr = res.roleIds ? res.roleIds.split(",") : [];
                this.context.store.dispatch(
                  initModals("dispatchRoleModal", {
                    userId: res.id || res.key,
                    defaultSource: this.state.fromData,
                    defaultTarget: targetArr,
                  }),
                );
              },
            },
            // ,
            // {
            //     type: 'confirm',
            //     actionName: '删除', // 默认actionName
            //     // 根据grid数据 自定义显示actionName
            //     handler: (res) => {
            //         fetchHandler(userDelete, {
            //             uid: res.key
            //         }).then((res) => {
            //             if (res.code === 'success') {
            //                 RefreshGrid(this.context.store, 'accountTable');
            //             }
            //         });
            //     }
            // }
          ],
        },
      ],
      tableParam: {
        pagecount: 10,
      },
      dataApi: getUserList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
    // home-form
    this.formConfig = {
      childItems: [
        {
          type: "input", // 定义表单元素基础类型
          inputType: "text", // 定义表单元素的子类型
          param: {
            // 定义表单元素的参数对象
            name: "name", // 参数名称
            type: "string", // 参数类型，用来做类型检测
          },
          placeholder: this.internationalization.placeholder1, // '请输入用户名称',
          labelName: this.internationalization.title6, // '用户名称', // label名称
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn4, // '查询',
              icon: "search",
            },
            {
              btnType: "button",
              text: this.internationalization.btn5, // '添加用户',
              icon: "plus",
              handler: (e) => {
                console.debug(this); // 当前上下文
                console.debug(e); // 暴露核心组件对象
                this.context.store.dispatch(initModals("addUserModal", e));
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "accountTable",
    };
  }

  componentWillMount() {
    this.params = {};
    this.getRoleList();
  }

  async getRoleList() {
    try {
      const resData = await getRoleList();
      let fromData = resData.data.data;
      fromData = JSON.parse(
        JSON.stringify(fromData)
          .replace(/id/g, "key")
          .replace(/childList/g, "children"),
      );
      this.setState({
        modalVisible: !1,
        fromData,
      });
    } catch (e) {
      console.debug(e);
    }
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>
      </div>
    );
    return (
      <div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
        {Content}
      </div>
    );
  }
}

export default injectIntl(Home);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/account/account.js